import { afterAuthPath } from "../lib/pendingPlan";
import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) return navigate("/login", { replace: true });
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(afterAuthPath(data.role), { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="grain min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <Loader2 size={40} className="text-neon animate-spin mx-auto mb-4" />
        <p className="text-neutral-400 uppercase tracking-[0.25em] text-xs">Signing you in…</p>
      </div>
    </div>
  );
}
